import './App.css';
import { ConfigProvider, theme } from 'antd';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/home/main';
import Automations from './pages/automate/main';
import Signup from './pages/login/main';
import InstaAccounts from './pages/instaAccounts/main';
import SignupTwo from './pages/signup/main';
import Oia from './pages/oia/main';

import FbRdr from './pages/fb-redirect/main';
import FbAPIRdr from './pages/fb-api-redirect/main';
import { Alert } from 'antd';
import ResetPassword from './pages/reset-password/main';
import YT from './pages/yt-automation/main';

function App() {
  
  return (
    <ConfigProvider
      button={{
        style: {
          borderRadius: 4
        }
      }}
      input={{
        style: {
          borderRadius: 4
        }
      }}
      modal={{
        style: {
          borderRadius: 4
        }
      }}
    >
      <div className="App">
      
        <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Signup />} />
        <Route path="/ig-connect" element={<SignupTwo />} />
        <Route path="/fb-rdr" element={<FbAPIRdr />} />
        <Route path="/fb-api-rdr" element={<FbAPIRdr />} />
        <Route path="/insta-accounts" element={<InstaAccounts />} />
        <Route path="/" element={<Home />} />
        <Route path="/manage-post/:id" element={<Automations />} />
        <Route path="/oia" element={<Oia />} />
        <Route path='/reset-password' element={<ResetPassword/>} />
        <Route path="/yt" element={<YT />} />
        </Routes>

      </div>
    </ConfigProvider>
  );
}

export default App;

